export const GET_LOYALTY_POINTS_MANUAL_ADJUST_REQUEST =
  "GET_LOYALTY_POINTS_MANUAL_ADJUST_REQUEST";
export const GET_LOYALTY_POINTS_MANUAL_ADJUST_SUCCESS =
  "GET_LOYALTY_POINTS_MANUAL_ADJUST_SUCCESS";
export const GET_LOYALTY_POINTS_MANUAL_ADJUST_FAILURE =
  "GET_LOYALTY_POINTS_MANUAL_ADJUST_FAILURE";
export const GET_LOYALTY_POINTS_MANUAL_ADJUST_LOADING =
  "GET_LOYALTY_POINTS_MANUAL_ADJUST_LOADING";

export const GET_SUBDEALER_LOYALTY_TRANSACTION_REQUEST =
  "GET_SUBDEALER_LOYALTY_TRANSACTION_REQUEST";
export const GET_SUBDEALER_LOYALTY_TRANSACTION_SUCCESS =
  "GET_SUBDEALER_LOYALTY_TRANSACTION_SUCCESS";
export const GET_SUBDEALER_LOYALTY_TRANSACTION_FAILURE =
  "GET_SUBDEALER_LOYALTY_TRANSACTION_FAILURE";
export const GET_SUBDEALER_LOYALTY_TRANSACTION_LOADING =
  "GET_SUBDEALER_LOYALTY_TRANSACTION_LOADING";
